(() => {
    var t, e = {
            9750: t => {
                t.exports = function(t, e, r) {
                    return t == t && (void 0 !== r && (t = t <= r ? t : r), void 0 !== e && (t = t >= e ? t : e)), t
                }
            },
            4691: (t, e, r) => {
                var o = r(9750),
                    n = r(4841);
                t.exports = function(t, e, r) {
                    return void 0 === r && (r = e, e = void 0), void 0 !== r && (r = (r = n(r)) == r ? r : 0), void 0 !== e && (e = (e = n(e)) == e ? e : 0), o(n(t), e, r)
                }
            },
            7239: (t, e, r) => {
                "use strict";
                var o = r(4486),
                    n = r.n(o);
                var i = r(4691),
                    s = r.n(i);

                function a(t, e, r) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = r, t
                }
                class c {
                    constructor(t) {
                        a(this, "onMouseEnter", (() => {
                            clearTimeout(this.leaveTimeout), this.store.setState({
                                isActive: !0
                            })
                        })), a(this, "onMouseMove", (t => {
                            const e = this.el.getBoundingClientRect(),
                                r = (t.clientX - e.left) / e.width,
                                o = (t.clientY - e.top) / e.height;
                            this.store.setState({
                                zoomTransform: [s()(r, 0, 1), s()(o, 0, 1)]
                            })
                        })), a(this, "onMouseLeave", (() => {
                            this.leaveTimeout = setTimeout((() => {
                                this.store.setState({
                                    isActive: !1
                                })
                            }), 300)
                        })), a(this, "onStoreChange", ((t, e) => {
                            const {
                                isActive: r,
                                zoomTransform: o
                            } = t;
                            r ? this.zoomContainer.classList.add("active") : this.zoomContainer.classList.remove("active"), this.zoomContainer.style.transform = "translate(-".concat(50 * o[0], "%, -").concat(50 * o[1], "%)")
                        })), a(this, "destroy", (() => {
                            this.unlisten.listen(this.onStoreChange), this.el.removeEventListener("mouseenter", this.onMouseEnter), this.el.removeEventListener("mousemove", this.onMouseMove), this.el.removeEventListener("mouseleave", this.onMouseLeave)
                        })), this.el = t, this.zoomContainer = t.querySelector(c.zoomSelector), this.store = (t => {
                            let e = null,
                                r = t,
                                o = [];
                            return {
                                getState: () => r,
                                setState: t => {
                                    e = r, r = Object.assign({}, r, t), (() => {
                                        for (var t = 0; t < o.length; t++) {
                                            var n = o[t];
                                            n && o.indexOf(n) > -1 && n(r, e)
                                        }
                                    })()
                                },
                                listen: t => {
                                    o.indexOf(t) > -1 || o.push(t)
                                },
                                unlisten: t => {
                                    let e = o.indexOf(t);
                                    e > -1 && o.splice(e, 1)
                                }
                            }
                        })({
                            zoomTransform: [0, 0],
                            isActive: !1
                        }), this.store.listen(this.onStoreChange), this.el.addEventListener("mouseenter", this.onMouseEnter), this.el.addEventListener("mousemove", this.onMouseMove), this.el.addEventListener("mouseleave", this.onMouseLeave)
                    }
                }
                a(c, "domSelector", ".image-zoom"), a(c, "zoomSelector", ".image-zoom__zoom");
                var l = r(2442),
                    d = r.n(l);
                d().prototype._touchActionValue = "pan-x pinch-zoom";
                var u = r(1763),
                    p = r.n(u),
                    m = r(4721),
                    v = r.n(m);
                const f = t => "$".concat(t / 100 % 1 == 0 ? t / 100 : (t / 100).toFixed(2)),
                    {
                        STORE: b,
                        RELATED_PRODUCTS: h
                    } = window,
                    y = document.querySelectorAll("[data-product-form]"),
                    _ = document.querySelectorAll("[data-subscription-form]"),
                    L = document.querySelectorAll(".product__price"),
                    g = document.querySelector(".product__price-suffix"),
                    S = document.querySelector(".product__price-suffix--subscription"),
                    E = document.querySelector(".product-hero-slider-mobile__container"),
                    q = document.querySelector(".product-hero-slider-desktop__container"),
                    F = document.querySelectorAll(".product-hero-slider__index-button--desktop"),
                    A = document.querySelector(".product-hero-slider__previous"),
                    x = document.querySelector(".product-hero-slider__next"),
                    M = document.querySelectorAll(c.domSelector),
                    T = document.querySelectorAll(".about__condition-drawer .drawer__trigger");
                (t => {
                    let {
                        mobileSliderEl: e,
                        desktopSliderEl: r,
                        desktopIndexButtonEls: o,
                        previousEl: i,
                        nextEl: s
                    } = t;
                    const a = t => {
                            n()(o, ((e, r) => {
                                r === t ? e.classList.add("active") : e.classList.remove("active")
                            }))
                        },
                        c = new(d())(e, {
                            cellAlign: "center",
                            contain: !1,
                            wrapAround: !0,
                            imagesLoaded: !0,
                            draggable: !0,
                            pageDots: !0,
                            prevNextButtons: !1,
                            selectedAttraction: .1,
                            friction: .8,
                            on: {
                                change: a
                            }
                        });
                    window.visualViewport.addEventListener("resize", (t => {
                        window.visualViewport.scale > 1 ? e.style.pointerEvents = "none" : e.style.pointerEvents = "all"
                    }));
                    const l = new(d())(r, {
                        cellAlign: "center",
                        contain: !0,
                        imagesLoaded: !0,
                        pageDots: !1,
                        draggable: !1,
                        prevNextButtons: !1,
                        selectedAttraction: .1,
                        friction: .8,
                        on: {
                            change: a
                        }
                    });
                    i && i.addEventListener("click", (() => {
                        l.previous()
                    })), s && s.addEventListener("click", (() => {
                        l.next()
                    })), n()(o, ((t, e) => {
                        t.addEventListener("click", (() => {
                            c.select(e), l.select(e)
                        }))
                    }))
                })({
                    mobileSliderEl: E,
                    desktopSliderEl: q,
                    desktopIndexButtonEls: F,
                    previousEl: A,
                    nextEl: x
                }), n()(y, (t => {
                    (t => {
                        let {
                            formEl: e,
                            priceEls: r,
                            listen: o,
                            onAddVariant: i,
                            setProductFormQuantity: s,
                            getState: a,
                            relatedProducts: c
                        } = t;
                        const l = e.querySelector(".product-form__minus"),
                            d = e.querySelector(".product-form__plus"),
                            u = e.querySelector(".product-form__quantity"),
                            m = e.querySelector('button[type="submit"]'),
                            b = Number(e.dataset.productForm),
                            h = (Boolean(e.dataset.headerForm), e.querySelector(".subscription-form__label-off")),
                            y = e.querySelectorAll(".subscription-form__label-bulk"),
                            _ = e.dataset.productPrice,
                            L = e.dataset.productCents,
                            g = Array.from(y).map(((t, e) => ({
                                el: t,
                                idx: e,
                                price: t.dataset.bulkPrice ? Number(t.dataset.bulkPrice) : Number(_),
                                quantity: t.dataset.quantity ? Number(t.dataset.quantity) : 1e5
                            })));
                        l.addEventListener("click", (() => {
                            1 !== a().productFormQuantity && s(a().productFormQuantity - 1)
                        })), d.addEventListener("click", (() => {
                            s(a().productFormQuantity + 1)
                        })), h && h.addEventListener("click", (() => {
                            s(1)
                        })), g.length > 0 && g.forEach((t => {
                            t.el.addEventListener("click", (() => {
                                s(t.quantity)
                            }))
                        })), e.addEventListener("submit", (t => {
                            p()(b) && (t.preventDefault(), i(b, a().productFormQuantity, {}, {
                                variantId: b,
                                quantity: a().productFormQuantity,
                                relatedProducts: c,
                            }))
                        })), o((t => {
                            if (h)
                                if (t.productFormShouldSubscribe) h.classList.remove("active"), g && g.length > 0 && g.forEach((t => t.el.classList.remove("active")));
                                else if (g && g.length > 0) {
                                g.forEach((t => t.el.classList.remove("active")));
                                const e = g.map((t => t.quantity)).filter(((e, r) => t.productFormQuantity >= e));
                                if (void 0 !== g[e.length - 1]) {
                                    const t = g[e.length - 1];
                                    h.classList.remove("active"), t.el.classList.add("active")
                                } else h.classList.add("active"), g.forEach((t => t.el.classList.remove("active")))
                            } else h.classList.add("active"), g.forEach((t => t.el.classList.remove("active")));
                            if (t.pendingAddVariantId === b) m.innerHTML = '<span class="button--scale__text">Adding…</span>', m.classList.add("loading"), m.disabled = !0;
                            else if (v()(t.addedVariantIds, b)) {
                                if (g && g.length > 0) {
                                    const e = g.map((t => t.quantity)).filter(((e, r) => t.productFormQuantity >= e));
                                    if (void 0 !== g[e.length - 1]) {
                                        const r = g[e.length - 1];
                                        m.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(r.price * t.productFormQuantity), "</span>")
                                    } else m.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(Number(L) * t.productFormQuantity), "</span>")
                                } else m.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(Number(L) * t.productFormQuantity), "</span>");
                                m.classList.remove("loading"), m.disabled = !1
                            } else {
                                if (g && g.length > 0) {
                                    const e = g.map((t => t.quantity)).filter(((e, r) => t.productFormQuantity >= e));
                                    if (void 0 !== g[e.length - 1]) {
                                        const r = g[e.length - 1];
                                        m.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(r.price * t.productFormQuantity), "</span>")
                                    } else m.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(Number(L) * t.productFormQuantity), "</span>")
                                } else m.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(Number(L) * t.productFormQuantity), "</span>");
                                m.classList.remove("loading"), m.disabled = !1
                            }
                            n()(r, (e => {
                                if (g && g.length > 0) {
                                    const r = g.map((t => t.quantity)).filter(((e, r) => t.productFormQuantity >= e));
                                    if (void 0 !== g[r.length - 1]) {
                                        const t = g[r.length - 1];
                                        e.innerHTML = f(t.price)
                                    } else e.innerHTML = _
                                } else e.innerHTML = _
                            })), u.innerHTML = t.productFormQuantity
                        }))
                    })({
                        formEl: t,
                        priceEls: L,
                        listen: b.listen,
                        getState: b.getState,
                        onAddVariant: b.addVariantAndOpenAddedModal,
                        setProductFormQuantity: b.setProductFormQuantity,
                        relatedProducts: h
                    })
                })), n()(_, (t => {
                    (t => {
                        let {
                            formEl: e,
                            priceEls: r,
                            suffixEl: o,
                            subscriptionSuffixEl: i,
                            listen: s,
                            getState: a,
                            onAddVariant: c,
                            onChangeShouldSubscribe: l,
                            setProductFormQuantity: d,
                            relatedProducts: u
                        } = t, m = e.dataset.subscriptionIntervalUnit, b = e.dataset.subscriptionIntervalFrequency;
                        const h = e.querySelector(".product-form__minus"),
                            y = e.querySelector(".product-form__plus"),
                            _ = e.querySelector(".product-form__quantity"),
                            L = e.querySelector('button[type="submit"]'),
                            g = e.querySelector(".subscription-form__frequency__container"),
                            S = e.querySelector(".subscription-form__frequency__select"),
                            E = e.querySelector(".subscription-form__frequency__title"),
                            q = e.querySelector(".subscription-form__frequency__subtitle"),
                            F = e.querySelector('input[name="id"]'),
                            A = e.querySelector(".subscription-form__label-on"),
                            x = e.querySelector(".subscription-form__label-off"),
                            M = e.querySelectorAll(".subscription-form__label-bulk"),
                            T = e.dataset.productPrice,
                            Q = e.dataset.productCents,
                            k = e.dataset.subscriptionPrice,
                            C = e.dataset.subscriptionForm,
                            H = Number(e.dataset.subscriptionVariantId),
                            P = Number(e.dataset.variantId),
                            //H = '31101536108626',
                            //P = Number(e.dataset.variantId),
                            w = Array.from(M).map(((t, e) => ({
                                el: t,
                                idx: e,
                                price: t.dataset.bulkPrice ? Number(t.dataset.bulkPrice) : Number(T),
                                quantity: t.dataset.quantity ? Number(t.dataset.quantity) : 1e5
                            }))),
                            O = t => {
                                if (A && x)
                                    if (t.productFormShouldSubscribe) A.classList.add("active"), x.classList.remove("active"), w && w.length > 0 && w.forEach((t => t.el.classList.remove("active")));
                                    else if (w && w.length > 0) {
                                    w.forEach((t => t.el.classList.remove("active")));
                                    const e = w.map((t => t.quantity)).filter(((e, r) => t.productFormQuantity >= e));
                                    if (void 0 !== w[e.length - 1]) {
                                        const t = w[e.length - 1];
                                        A.classList.remove("active"), x.classList.remove("active"), t.el.classList.add("active")
                                    } else A.classList.remove("active"), x.classList.add("active"), w.forEach((t => t.el.classList.remove("active")))
                                } else A.classList.remove("active"), x.classList.add("active"), w.forEach((t => t.el.classList.remove("active")));
                                if (g && (t.productFormShouldSubscribe ? g.classList.remove("dn") : g.classList.add("dn")), t.pendingAddVariantId === P || t.pendingAddVariantId === H) L.innerHTML = '<span class="button--scale__text">Adding…</span>', L.classList.add("loading"), L.disabled = !0;
                                else if (v()(t.addedVariantIds, P) || v()(t.addedVariantIds, H)) {
                                    if (t.productFormShouldSubscribe) L.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(100 * Number(k.replace("$", "")) * t.productFormQuantity), "</span>");
                                    else if (w && w.length > 0) {
                                        const e = w.map((t => t.quantity)).filter(((e, r) => t.productFormQuantity >= e));
                                        if (void 0 !== w[e.length - 1]) {
                                            const r = w[e.length - 1];
                                            L.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(r.price * t.productFormQuantity), "</span>")
                                        } else L.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(Number(Q) * t.productFormQuantity), "</span>")
                                    } else L.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(Number(Q) * t.productFormQuantity), "</span>");
                                    L.classList.remove("loading"), L.disabled = !1
                                } else if (t.productFormShouldSubscribe) L.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(100 * Number(k.replace("$", "")) * t.productFormQuantity), "</span>");
                                else if (w && w.length > 0) {
                                    const e = w.map((t => t.quantity)).filter(((e, r) => t.productFormQuantity >= e));
                                    if (void 0 !== w[e.length - 1]) {
                                        const r = w[e.length - 1];
                                        L.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(r.price * t.productFormQuantity), "</span>")
                                    } else L.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(Number(Q) * t.productFormQuantity), "</span>")
                                } else L.innerHTML = '<span class="button--scale__text">Add to Cart - '.concat(f(Number(Q) * t.productFormQuantity), "</span>");
                                n()(r, (e => {
                                    if (t.productFormShouldSubscribe) e.innerHTML = k;
                                    else if (w && w.length > 0) {
                                        const r = w.map((t => t.quantity)).filter(((e, r) => t.productFormQuantity >= e));
                                        if (void 0 !== w[r.length - 1]) {
                                            const t = w[r.length - 1];
                                            e.innerHTML = f(t.price)
                                        } else e.innerHTML = T
                                    } else e.innerHTML = T
                                })), o && (t.productFormShouldSubscribe ? o.classList.add("dn") : o.classList.remove("dn")), i && (t.productFormShouldSubscribe ? i.classList.remove("dn") : i.classList.add("dn")), t.productFormShouldSubscribe && H ? F.value = H : F.value = P;
                                const e = S.querySelector('option[value="'.concat(b, '"]'));
                                E.innerHTML = e.dataset.title, q.innerHTML = e.dataset.subtitle, _.innerHTML = t.productFormQuantity
                            };
                        S.addEventListener("change", (t => {
                            b = t.target.value, O(a())
                        })), h.addEventListener("click", (() => {
                            1 !== a().productFormQuantity && d(a().productFormQuantity - 1)
                        })), y.addEventListener("click", (() => {
                            d(a().productFormQuantity + 1)
                        })), x.addEventListener("click", (() => {
                            d(1), l(!1)
                        })), A.addEventListener("click", (() => {
                            d(1), l(!0)
                        })), w.length > 0 && w.forEach((t => {
                            t.el.addEventListener("click", (() => {
                                d(t.quantity), l(!1)
                            }))
                        })), e.addEventListener("submit", (t => {
                            if (!p()(P)) return;
                            t.preventDefault();
                            const {
                                productFormShouldSubscribe: e,
                                productFormQuantity: r
                            } = a();

                            // Get the selected selling plan ID
                            const selectedPlanElement = document.querySelector('.subscription-form__frequency__select');
                            const selectedPlanID = selectedPlanElement.options[selectedPlanElement.selectedIndex].getAttribute('data-sellingplanvalue');
                                                  
                            e ? c(H, r, {
                                //properties: {
                                    //shipping_interval_unit_type: m,
                                    //shipping_interval_frequency: b,
                                    //subscription_id: C
                                //},
                              selling_plan: selectedPlanID,
                            }, {
                                variantId: H,
                                quantity: r,
                                relatedProducts: u
                            }) : c(P, r, {}, {
                                variantId: P,
                                quantity: r,
                                relatedProducts: u
                            })
                        })), s(O)
                    })({
                        formEl: t,
                        priceEls: L,
                        suffixEl: g,
                        subscriptionSuffixEl: S,
                        listen: b.listen,
                        getState: b.getState,
                        onAddVariant: b.addVariantAndOpenAddedModal,
                        onChangeShouldSubscribe: b.setProductFormShouldSubscribe,
                        setProductFormQuantity: b.setProductFormQuantity,
                        relatedProducts: h
                    })
                })), n()(M, (t => new c(t))), (t => {
                    let {
                        faqEls: e
                    } = t;
                    n()(e, (t => {
                        t.addEventListener("click", (() => {
                            n()(e, (e => {
                                e === t ? e.classList.toggle("active") : e.classList.remove("active")
                            }))
                        }))
                    }))
                })({
                    faqEls: T
                })
            }
        },
        r = {};

    function o(t) {
        var n = r[t];
        if (void 0 !== n) return n.exports;
        var i = r[t] = {
            id: t,
            loaded: !1,
            exports: {}
        };
        return e[t].call(i.exports, i, i.exports, o), i.loaded = !0, i.exports
    }
    o.m = e, t = [], o.O = (e, r, n, i) => {
        if (!r) {
            var s = 1 / 0;
            for (d = 0; d < t.length; d++) {
                for (var [r, n, i] = t[d], a = !0, c = 0; c < r.length; c++)(!1 & i || s >= i) && Object.keys(o.O).every((t => o.O[t](r[c]))) ? r.splice(c--, 1) : (a = !1, i < s && (s = i));
                if (a) {
                    t.splice(d--, 1);
                    var l = n();
                    void 0 !== l && (e = l)
                }
            }
            return e
        }
        i = i || 0;
        for (var d = t.length; d > 0 && t[d - 1][2] > i; d--) t[d] = t[d - 1];
        t[d] = [r, n, i]
    }, o.n = t => {
        var e = t && t.__esModule ? () => t.default : () => t;
        return o.d(e, {
            a: e
        }), e
    }, o.d = (t, e) => {
        for (var r in e) o.o(e, r) && !o.o(t, r) && Object.defineProperty(t, r, {
            enumerable: !0,
            get: e[r]
        })
    }, o.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")()
        } catch (t) {
            if ("object" == typeof window) return window
        }
    }(), o.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), o.r = t => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, o.nmd = t => (t.paths = [], t.children || (t.children = []), t), (() => {
        var t = {
            387: 0
        };
        o.O.j = e => 0 === t[e];
        var e = (e, r) => {
                var n, i, [s, a, c] = r,
                    l = 0;
                if (s.some((e => 0 !== t[e]))) {
                    for (n in a) o.o(a, n) && (o.m[n] = a[n]);
                    if (c) var d = c(o)
                }
                for (e && e(r); l < s.length; l++) i = s[l], o.o(t, i) && t[i] && t[i][0](), t[s[l]] = 0;
                return o.O(d)
            },
            r = self.webpackChunkcurist = self.webpackChunkcurist || [];
        r.forEach(e.bind(null, 0)), r.push = e.bind(null, r.push.bind(r))
    })();
    var n = o.O(void 0, [644, 124], (() => o(7239)));
    n = o.O(n)
})();